import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconLeaderboard"><Path d="M9 6C8.72386 6 8.5 6.22386 8.5 6.5V18H15.5V6.5C15.5 6.22386 15.2761 6 15 6H9Z" fill="currentColor"/><Path d="M1 8.5C0.723858 8.5 0.5 8.72386 0.5 9V17.5C0.5 17.7761 0.723858 18 1 18H7V9.5C7 8.94772 6.55228 8.5 6 8.5H1Z" fill="currentColor"/><Path d="M17 10V18H23C23.2761 18 23.5 17.7761 23.5 17.5V10.5C23.5 10.2239 23.2761 10 23 10H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLeaderboard;
